var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google (3) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 28C9.3858 28 4 22.6144 4 16C4 9.38585 9.3858 4.00005 16 4.00005C19.1843 3.99126 22.24 5.25667 24.4858 7.51441L24.8928 7.92142L20.8501 11.9573L20.4428 11.55C18.5164 9.62692 15.571 9.16235 13.146 10.3991C10.7211 11.6358 9.3678 14.2931 9.79365 16.9817C10.2193 19.6703 12.3274 21.7792 15.0158 22.2063C17.7042 22.6334 20.3621 21.2816 21.6001 18.8573H15.4285V13.143H27.6643L27.7572 13.6C27.9181 14.39 27.9995 15.1939 28 16C28 22.6144 22.6144 28 16 28ZM16 5.14304C10.0142 5.14304 5.14279 10.0143 5.14279 16C5.14279 21.9858 10.0142 26.8572 16 26.8572C21.9857 26.8572 26.8572 21.9858 26.8572 16C26.8567 15.426 26.8113 14.8528 26.7214 14.2857H16.5715V17.7143H23.2714L23 18.4785C21.9119 21.5465 18.9529 23.5488 15.7001 23.4178C12.4475 23.287 9.6591 21.0537 8.82079 17.9081C7.98248 14.7627 9.28996 11.4379 12.046 9.70581C14.8022 7.97353 18.3651 8.23762 20.8356 10.3572L23.2643 7.92875C21.274 6.12804 18.6838 5.13467 16 5.14304Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGoogle);
export default __webpack_public_path__ + "static/media/socialGoogle.bf952f84d09594adca50303fcc8f37a6.svg";
export { ForwardRef as ReactComponent };